import { useUserZStore } from './user-store';

export * from './user-store';

export const syncStore = () => {
  useUserZStore.persist.rehydrate();
};
